import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { getFormBaseValidationRule } from "../../utils/form/form-utils";
import EzControlledInputWithFloatingLabel from "../../common/EzForm/EzControlledInput/WithFloatingLabel";
import { Box, Button, Typography } from "@mui/material";
import styleCss from "./style.module.css";
import { getApiParam } from "../../services/PostAPI.js";
import { Navigate } from "react-router-dom";
import EzControlledPasswordWithFloatingLabel from "../../common/EzForm/EZControlledPassword/WithFloatingLabel";
import { useStyles } from "./style";
import Logoicon from "../../images/logo.png";
import { API_URL } from "../../utils/constant.js";

export default function Forgot(props) {
  const classes = useStyles();
  const formFieldValueMap = {
    email: "",
  };
  const {
    control,
    formState: { errors, isDirty },
    watch,
    handleSubmit,
    reset,
  } = useForm({
    defaultValues: useMemo(() => {
      return formFieldValueMap;
    }, [formFieldValueMap]),
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  const genericInput = (name, label) => {
    return (
      <EzControlledInputWithFloatingLabel
        name={name}
        control={control}
        label={label}
        rules={getFormBaseValidationRule().DEFAULT.VALIDATION_RULE}
        isError={errors[name]}
        errorMsg={getFormErrorMessage(name)}
      />
    );
  };

  const onSubmit = async (data) => {
    setIsLoading(true);
    setError(false);
    setSuccess(false);
    try {
      let res = await getApiParam(API_URL.forgot, `?email=${data?.email}`);
      if (res.message !== "") {
        setSuccess(true);
        setSuccessMessage(
          "We've sent an email to your registered email address for password reset.",
        );
      } else {
        setError(true);
        setErrorMessage("Invalid Email");
        localStorage.removeItem("token");
        localStorage.removeItem("username");
      }
    } catch (err) {
      setError(true);
      setErrorMessage("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };
  if (
    localStorage.getItem("token") !== "" &&
    localStorage.getItem("token") != null &&
    localStorage.getItem("token") !== undefined
  ) {
    return <Navigate to="/dashboard" />;
  }
  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
      <Box className={styleCss.loginbox}>

        <Box className={styleCss.logoadmin}>
          <img src="/RezRevolution-logo.png" alt="Rez Revolution" />
        </Box>

        {/* Title */}
        <Box className={styleCss.logotext}>Forgot Password?</Box>
        <Box className={styleCss.subtitle}>
          Enter your email and we'll send you a reset link
        </Box>

        {/* Error Message */}
        {error && (
          <Box className={styleCss.errorMessage}>
            {errorMessage}. Please enter a valid email and try again.
          </Box>
        )}

        {/* Success Message */}
        {success && (
          <Box className={styleCss.successMessage}>{successMessage}</Box>
        )}

        {/* Email Field */}
        <Box className={styleCss.formField}>
          <label className={styleCss.user_icon}>
            <span className="pi pi-envelope"></span>
          </label>
          {genericInput("email", "Enter your email")}
        </Box>

        {/* Buttons */}
        <Box className={classes.buttonpan}>
          <Button
            variant="contained"
            color="secondary"
            className={classes.loginbutton}
            type="submit"
            disabled={isLoading}
          >
            {isLoading ? (
              <span
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <i
                  className="pi pi-spin pi-spinner"
                  style={{ fontSize: "18px" }}
                ></i>
                Sending...
              </span>
            ) : (
              "Send Reset Link"
            )}
          </Button>

          <Button
            className={classes.forgot}
            type="button"
            onClick={props?.backtologin}
          >
            ← Back to Sign In
          </Button>
        </Box>

        {/* Footer */}
        {/* <Box className={styleCss.footerText}>
          Powered by{" "}
          <a
            href="https://zoomrentals.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Zoom Rental
          </a>
        </Box> */}
      </Box>
    </form>
  );
}
